<template>
  <div>
    <TitleCard
      title="市场需求"
      :loading="loading"
      :isEmpty="isEmpty"
      :type="'firstCard'"
      class="marketDemandCard"
      @moreClick="toRouter('techDealInfos')"
      :isTabs="isTabs"
      :tabList="tabList"
      @selectTab="selectTab"
      :selectedIndx="selectedIndx"
    >
      <div class="searchCard">
        <MarketDemand :tableList="tableList"></MarketDemand>
      </div>
    </TitleCard>
  </div>
</template>
<script>
import { Mixin } from '@/views/TechnicalRLibrary/mixins'
import MarketDemand from '@/components/common/MarketDemand'
const industryList = require('@/utils/industryList')
export default {
  props: {
    isTabs: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tabList: industryList.industryLists,
      selectedIndx: 0,
      loading: false,
      isEmpty: false,
      selectVal: industryList.industryLists[0]
    }
  },
  mixins: [Mixin],
  components: {
    MarketDemand
  },

  methods: {
    // tab切换
    selectTab(val) {
      this.selectedIndx = val.index
      this.params.industrialType = val.tab.key
      this.selectVal = val.tab
      this.init('all')
    },
    toRouter(router) {
      this.$router.push({
        name: router,
        params: { selectVal: JSON.stringify(this.selectVal) }
      })
    }
  }
}
</script>
